import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import FilterUser from "../components/UsersListLayer";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Farmers" />

        {/* UsersListLayer */}
        <FilterUser />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
